import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    Utilities.inputFile();
    Utilities.initTinymce();
    Utilities.initCocoon();
    Utilities.initSortable();
    Utilities.triggerToggleVisibility();
    Utilities.setDefaultVisibility();
    Courses.correctQuizCheckboxes();

    Utilities.handleEvent('#quiz-form-container', 'cocoon:after-insert', function() {
      Utilities.inputFile();
      Courses.correctQuizCheckboxes();
    });

    const sectionId = this.element.dataset.selectedItemSectionIdValue;
    if (sectionId) {
      const details = document.querySelector(`details.js-item-sortable[data-id="${sectionId}"]`);
      if (details) details.setAttribute('open', '');
    }
  }
}
